
export enum EnvironmentNames {
    enterprise = 'Ent',
    dev = 'Dev',
    test = 'Test',
    testlocal = "Testlocal",
    stage = 'Stage',
    prod = 'Prod',
  }